export default "__VITE_ASSET__BdxdmGF___"